import { React } from "react";
import { Typography, Box, Divider } from "@mui/material";
import MzLink from "@markaaz/ui/MzLink";
import MzButton from "@markaaz/ui/MzButton";

const sx = {
  root: {
    textAlign: "center",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  divider: {
    margin: "18px 0px",
    "@media  (max-height: 599px)": {
      margin: "5px"
    },
    backgroundColor: "blue.c20",
    width: "1280px"
  }
};

function AuthFooterLink(props) {
  return (
    <Box sx={sx.root}>
      <Box>
        <Divider sx={sx.divider} />
        <Typography variant="caption" color={(theme) => theme.palette.darkBlue.c70}>
          Need assistance?&nbsp;
          <MzLink href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z" target="_blank">
            Contact Us
          </MzLink>
        </Typography>
      </Box>
      <MzButton
        onClick={() => {
          var _hsp = (window._hsp = window._hsp || []);
          _hsp.push(["showBanner"]);
        }}
      >
        Cookie Settings
      </MzButton>
    </Box>
  );
}

export default AuthFooterLink;
